import SeoPage from "../components/SeoPage";

export default function Internship() {
  return (
    <SeoPage
      title="Internship in Web Development | Arviko"
      description="Join Arviko internship and work on real-time projects."
      heading="Web Development Internship Program"
    >
      <p>
        Gain hands-on experience with real-time projects and expert mentorship.
      </p>
    </SeoPage>
  );
}